import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { AccountingApi } from '_api';
import { handleError, handleResponse } from '_helpers/api';

export const getTransactionCategories = createAsyncThunk(
  'transactionCategories/getTransactionCategories',
  async function ({ customerId }, { rejectWithValue }) {
    try {
      const response = await AccountingApi.getTransactionCategories({
        customerId,
      });

      return handleResponse(response);
    } catch (e) {
      return rejectWithValue(handleError(e));
    }
  }
);

export const addTransactionCategory = createAsyncThunk(
  'transactionCategories/addTransactionCategory',
  async function ({ customerId, category }, { dispatch, rejectWithValue }) {
    try {
      await AccountingApi.addTransactionCategory({
        customerId,
        category,
      });

      dispatch(getTransactionCategories({ customerId }));
    } catch (e) {
      return rejectWithValue(handleError(e));
    }
  }
);

export const deleteTransactionCategory = createAsyncThunk(
  'transactionCategories/deleteTransactionCategory',
  async function ({ customerId, categoryId }, { dispatch, rejectWithValue }) {
    try {
      await AccountingApi.deleteTransactionCategory({
        customerId,
        categoryId,
      });

      dispatch(getTransactionCategories({ customerId }));
    } catch (e) {
      return rejectWithValue(handleError(e));
    }
  }
);

const transactionCategoriesSlice = createSlice({
  name: 'transactionCategories',
  initialState: {
    category: null,
    data: [],
    error: null,
    loading: 0,
  },
  reducers: {
    refreshCategory(state, action) {
      state.category = action.payload;
    },
    resetData(state) {
      state.data = {};
    },
    resetError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTransactionCategories.pending, (state) => {
        state.error = null;
        state.loading += 1;
      })
      .addCase(getTransactionCategories.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading -= 1;
      })
      .addCase(getTransactionCategories.rejected, (state, action) => {
        state.error = action.payload;
        state.loading -= 1;
      });

    builder
      .addCase(addTransactionCategory.pending, (state) => {
        state.error = null;
        state.loading += 1;
      })
      .addCase(addTransactionCategory.fulfilled, (state) => {
        state.loading -= 1;
      })
      .addCase(addTransactionCategory.rejected, (state, action) => {
        state.error = action.payload;
        state.loading -= 1;
      });

    builder
      .addCase(deleteTransactionCategory.pending, (state) => {
        state.error = null;
        state.loading += 1;
      })
      .addCase(deleteTransactionCategory.fulfilled, (state) => {
        state.loading -= 1;
      })
      .addCase(deleteTransactionCategory.rejected, (state, action) => {
        state.error = action.payload;
        state.loading -= 1;
      });
  },
});

export const { refreshCategory, resetData, resetError } = transactionCategoriesSlice.actions;

export default transactionCategoriesSlice.reducer;
